module.exports = __webpack_public_path__ + "img/right_more.fd202fee.png";